import React, {useEffect} from 'react';
import {Button, Col, FormGroup, Input, Label, Row} from 'reactstrap';
import {RefreshCcw, Search} from 'react-feather';
import {useFormik} from 'formik';
import {useDispatch, useSelector} from "react-redux";
import {
    getCities,
    getCitiesReset,
    getCountries,
    getGoalAttr,
    getRegions,
    getRegionsReset,
    getStates,
    getStatesReset
} from "../../redux/actions/PublicActions";
import Select from "react-select";
import Flatpickr from "react-flatpickr";

const AdminFilters = ({onSubmit, onClear, role = 'rd'}) => {
    const dispatch = useDispatch()

    const {
        getCountryLoading,
        getCountryData,

        getRegionLoading,
        getRegionData,

        getStateLoading,
        getStateData,

        getCityLoading,
        getCityData,

        getGoalAttrLoading,
        getGoalAttrData,
    } = useSelector(state => state.publicReducer)

    useEffect(() => {
        dispatch(getCountries())
        dispatch(getGoalAttr())
    }, []);

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            country: '',
            region: '',
            state: '',
            city: '',
            industry: '',
            speciality: '',
            status: '',
            companyName: '',
            brandOwnerName: '',
            subscriptionPlan: '',
            date: ''
        },
        onSubmit: values => {
            onSubmit(values)
        }
    });

    const {
        values,
        handleChange,
        handleSubmit,
        setFieldValue,
        resetForm
    } = formik;

    const getRegionsById = (e) => {
        dispatch(getRegions({
            country_id: e.id
        }))
        setFieldValue('country', e)
        setFieldValue('region', '')
        setFieldValue('state', '')
        setFieldValue('city', '')
        dispatch(getStatesReset())
        dispatch(getCitiesReset())
    }

    const getStatesById = (e) => {
        dispatch(getStates({
            region_id: e.id
        }))
        setFieldValue('region', e)
        setFieldValue('state', '')
        setFieldValue('city', '')
        dispatch(getCitiesReset())
    }

    const getCitiesById = (e) => {
        dispatch(getCities({
            state_id: [e.id]
        }))
        setFieldValue('state', e)
        setFieldValue('city', '')
    }

    const clearData = () => {
        onClear()
        resetForm()
        dispatch(getRegionsReset())
        dispatch(getStatesReset())
        dispatch(getCitiesReset())
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Row form className="mt-1 mb-50">
                    {role === 'rd' && (
                        <>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="name" className='font-weight-bold'>Name:</Label>
                                    <Input
                                        id="name"
                                        placeholder="Name"
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="email" className='font-weight-bold'>Email:</Label>
                                    <Input
                                        type="email"
                                        id="email"
                                        placeholder="Email"
                                        name="email"
                                        value={values.email}
                                        onChange={handleChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="industry" className='font-weight-bold'>Industry:</Label>
                                    <Select
                                        id='industry'
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        options={getGoalAttrData?.industry || []}
                                        value={values.industry}
                                        onChange={(e) => {
                                            setFieldValue('industry', e)
                                        }}
                                        isDisabled={getGoalAttrLoading}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="speciality" className='font-weight-bold'>Speciality:</Label>
                                    <Select
                                        id='speciality'
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        options={getGoalAttrData?.speciality || []}
                                        value={values.speciality}
                                        onChange={(e) => {
                                            setFieldValue('speciality', e)
                                        }}
                                        isDisabled={getGoalAttrLoading}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="country" className='font-weight-bold'>Country:</Label>
                                    <Select
                                        id='country'
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        options={getCountryData || []}
                                        value={values.country}
                                        onChange={(e) => {
                                            getRegionsById(e)
                                        }}
                                        isDisabled={getCountryLoading || getRegionLoading || getStateLoading || getCityLoading}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="region" className='font-weight-bold'>Region:</Label>
                                    <Select
                                        id='region'
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        options={getRegionData || []}
                                        value={values.region}
                                        onChange={(e) => {
                                            getStatesById(e)
                                        }}
                                        isDisabled={getCountryLoading || getRegionLoading || getStateLoading || getCityLoading}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="state" className='font-weight-bold'>State:</Label>
                                    <Select
                                        id='state'
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        options={getStateData || []}
                                        value={values.state}
                                        onChange={(e) => {
                                            getCitiesById(e)
                                        }}
                                        isDisabled={getCountryLoading || getRegionLoading || getStateLoading || getCityLoading}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="city" className='font-weight-bold'>City:</Label>
                                    <Select
                                        id='city'
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        options={getCityData || []}
                                        value={values.city}
                                        onChange={(e) => {
                                            setFieldValue('city', e)
                                        }}
                                        isDisabled={getCountryLoading || getRegionLoading || getStateLoading || getCityLoading}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="status" className='font-weight-bold'>Status:</Label>
                                    <Select
                                        id='speciality'
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        options={[
                                            {id: 1, value: "enabled", label: "Enabled"},
                                            {id: 2, value: "disabled", label: "Disabled"}
                                        ]}
                                        value={values.status}
                                        onChange={(e) => {
                                            setFieldValue('status', e)
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </>
                    )}
                    {role === 'brand' && (
                        <>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="companyName" className='font-weight-bold'>Company Name:</Label>
                                    <Input
                                        id="companyName"
                                        placeholder="Company Name"
                                        name="companyName"
                                        value={values.companyName}
                                        onChange={handleChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="brandOwnerName" className='font-weight-bold'>Brand Owner Name:</Label>
                                    <Input
                                        id="brandOwnerName"
                                        placeholder="Brand Owner Name"
                                        name="brandOwnerName"
                                        value={values.brandOwnerName}
                                        onChange={handleChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="4">
                                <FormGroup>
                                    <Label for="subscriptionPlan" className='font-weight-bold'>Subscription Plan:</Label>
                                    <Select
                                        id='subscriptionPlan'
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        options={[
                                            {id: 1, value: "", label: "All Subscriptions"},
                                            {id: 2, value: "monthly", label: "Monthly Subscription"},
                                            {id: 3, value: "quarterly", label: "Quarterly Subscription"},
                                            {id: 4, value: "yearly", label: "Annual Subscription"}
                                        ]}
                                        value={values.subscriptionPlan}
                                        onChange={(e) => {
                                            setFieldValue('subscriptionPlan', e)
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg='3' md='4'>
                                <FormGroup>
                                    <Label for='date' className='font-weight-bold'>Date:</Label>
                                    <Flatpickr
                                        className='form-control'
                                        id='date'
                                        placeholder='Date'
                                        options={{mode: 'range', dateFormat: 'M d, Y'}}
                                        onChange={(date) => setFieldValue('date', date)}
                                        value={values.date}
                                    />
                                </FormGroup>
                            </Col>
                        </>
                    )}
                    <Col lg="3" md="4">
                        <FormGroup>
                            <Label for="status" className='font-weight-bold'>Action:</Label>
                            <div>
                                <Button.Ripple className="btn-icon mr-1" color="primary" type='submit'>
                                    <Search size={16}/>
                                </Button.Ripple>
                                <Button.Ripple className="btn-icon" outline color="primary" onClick={clearData}>
                                    <RefreshCcw size={16}/>
                                </Button.Ripple>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </form>
        </>
    );
};

export default AdminFilters;